module.exports = __webpack_public_path__ + "img/menu-chevron-left.b040129e.svg";